import React from 'react';
import { UMALandingPage } from './UMALandingPage';

/**
 * /find-programs/ultimate-medical-academy
 *
 * Same Ultimate Medical Academy page, opening on the ZIP question instead of
 * the program picker. Visitors arriving here are browsing rather than shopping
 * for a named program, so location is the lower-commitment first ask.
 */
export function UMAFindProgramsPage() {
  return <UMALandingPage zipFirst backUrl="/find-programs/ultimate-medical-academy" data-id="element-3236" data-mp="mopwzu9f3eyd" />;
}